import { nativeReactRoutes } from "./LoginScreen";

const INVENTORY_MAP_ROUTES = new Set([
  "map_view",
  "inventory_site",
  "inventory_config",
  "map_config",
  "connector",
  "task_status",
]);

export function routeNeedsNativeData(routeId: string): boolean {
  if (routeId === "account_activity") return true;
  if (INVENTORY_MAP_ROUTES.has(routeId)) return true;
  return nativeReactRoutes.has(routeId);
}
